

























































































































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import ScientficProjectAddInfo from '../scientficProjectAddInfo.vue'
import Appconst from '../../../../lib/appconst';
@Component({
    name:'scientficProjectDetail',
    components: {
        ScientficProjectAddInfo
    }
})
export default class ScientficProjectDetail extends AbpBase  {
    initData:any = {
        loading: true,
        resData: {},
        modalData: {
            status: false,
            loading: true
        },
        verifyData: {
            status: false
        },
        showAudit: false,
        fileUrl: Appconst.fileUrl,  //附件上传地址
        userInfo:{}, // 当前用户信息
    }
    //弹窗状态
    ShowModal(status:boolean) {
        this.initData.modalData.status = status;
    }
    //审核
    async Audit(type:any) {
        let data:any = {
            id: this.initData.resData.id,
            isPass: !!type,
        };
        this.initData.verifyData.status = false;
        if(type){
            await Ajax.post('/api/services/app/ResearchProject/AuditProjectAsync', data).then((res:any)=>{
                this.$Modal.success({
                    title: '科技项目审核',
                    content: '<p>项目审核已通过！</p><p>已成功公开！</p>'
                });
                this.GetData();
            });
        }else{
            this.$Modal.confirm({
                title: '科技项目审核',
                content: '确定要驳回该科研项目吗？',
                onOk: async ()=>{                        
                    await Ajax.post('/api/services/app/ResearchProject/AuditProjectAsync', data);
                    this.$Message.success('操作成功!');
                    this.$router.push({
                        name:'scientficProject'
                    })
                }
            })
        }
    }
    //重置月份弹窗loading
    resetMonthLoading() {
        setTimeout(() => {
            this.initData.modalData.loading = false;
            this.$nextTick(() => {
                this.initData.modalData.loading = true;
            });
        }, 1000);
    }
    //重置弹窗
    ResetForm(type:any) {
        if(!type){
            (this as any).$refs.ScientficProjectAddInfo.ResetForm();
        }
    }
    //项目提交
    Submit() {
        (this as any).$refs.ScientficProjectAddInfo.Submit('edit');
    }
    async GetDic() {
        //获取当前用户权限
        await this.$store.dispatch('session/init');
        this.initData.showAudit = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.RM.C.Audit'];
    }
    // 获取数据
    GetData() {
        this.initData.loading = true;
        Ajax.get('/api/services/app/ResearchProject/GetProjectDetailAsync?Id='+this.initData.id).then((res:any)=>{
            this.initData.resData = res.data.result;
            (this.$parent as any).SetName(res.data.result.projectName)
            this.initData.loading = false;
        })
    }
    async mounted() {
        this.initData.id = this.$route.query.id;
        await this.GetDic();
        this.GetData();
        // 获取当前登录用户信息
        await this.$store.dispatch('project/GetAllUser');
        this.initData.userInfo = this.$store.state.session.user;
    }
}
